import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { Link, usePage } from "@inertiajs/inertia-react";
import { BanIcon, TrashIcon } from "@heroicons/react/outline";
import { CalendarIcon, InformationCircleIcon } from "@heroicons/react/solid";
import PageHeading from "@/Components/PageHeading";
import { Inertia } from "@inertiajs/inertia";
import cx from "classnames";

const breadcrumb = [
    { name: "Dashboard", route: route("dashboard") },
    { name: "Notification", route: null },
];

const Notification = () => {
    const { notifications } = usePage().props;

    const len = notifications.length;

    function handleReadAll(e) {
        e.preventDefault();
        Inertia.get(route("notifications.readAll"));
    }

    function handleDeleteAll(e) {
        e.preventDefault();
        Inertia.get(route("notifications.deleteAll"));
    }

    function handleRead(e, id) {
        e.preventDefault();
        Inertia.get(route("notifications.read", id));
    }

    function handleDelete(e, id) {
        e.preventDefault();
        Inertia.get(route("notifications.delete", id));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Notifications"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-end space-x-6 px-4 py-4">
                        <Link
                            className="text-sm text-blue-600"
                            onClick={(e) => handleReadAll(e)}
                        >
                            Mark all as Read
                        </Link>
                        <Link
                            className="text-sm text-red-600"
                            onClick={(e) => handleDeleteAll(e)}
                        >
                            Delete All
                        </Link>
                    </div>
                    <div className="overflow-hidden bg-white shadow sm:rounded-md">
                        <ul className="divide-y divide-gray-200">
                            {len === 0 && (
                                <div className="px-4 py-4 text-center sm:px-6">
                                    <BanIcon className="mx-auto h-12 w-12 text-gray-400" />
                                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                                        No Notifications
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500">
                                        No new notifications available right
                                        now.
                                    </p>
                                    <p className="mt-1 text-sm text-gray-500">
                                        Comeback Later
                                    </p>
                                </div>
                            )}
                            {notifications.map((notification) => (
                                <li key={notification.id}>
                                    <div
                                        className={cx(
                                            "flex items-center px-4 py-4 hover:bg-gray-50 sm:px-6",
                                            {
                                                "bg-gray-50":
                                                    notification.read_at,
                                            }
                                        )}
                                    >
                                        <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                                            <div className="truncate">
                                                <div className="flex text-sm">
                                                    <p className="truncate font-medium text-indigo-600">
                                                        {notification.type}
                                                    </p>
                                                </div>
                                                <div className="mt-2 flex">
                                                    <p>
                                                        {typeof notification
                                                            .data.message ===
                                                        "string" ? (
                                                            notification.data
                                                                .message
                                                        ) : (
                                                            <>
                                                                <ul>
                                                                    {notification.data.message.map(
                                                                        (
                                                                            {
                                                                                row,
                                                                                message,
                                                                            },
                                                                            idx
                                                                        ) => (
                                                                            <li
                                                                                key={
                                                                                    idx
                                                                                }
                                                                            >
                                                                                <p
                                                                                    className={
                                                                                        "space-x-1 text-sm text-red-600"
                                                                                    }
                                                                                >
                                                                                    <span>
                                                                                        #
                                                                                        {
                                                                                            row
                                                                                        }
                                                                                    </span>
                                                                                    <span>
                                                                                        {
                                                                                            message
                                                                                        }
                                                                                    </span>
                                                                                </p>
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            </>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="mt-2 flex">
                                                    <div className="flex items-center text-sm text-gray-500">
                                                        <CalendarIcon
                                                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                                                            aria-hidden={true}
                                                        />
                                                        <p>
                                                            {notification.date}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                {notification.read_at ? (
                                                    <Link
                                                        onClick={(e) =>
                                                            handleDelete(
                                                                e,
                                                                notification.id
                                                            )
                                                        }
                                                    >
                                                        <TrashIcon className="h-5 w-5 text-gray-400 hover:text-red-600" />
                                                    </Link>
                                                ) : (
                                                    <Link
                                                        onClick={(e) =>
                                                            handleRead(
                                                                e,
                                                                notification.id
                                                            )
                                                        }
                                                    >
                                                        <InformationCircleIcon className="h-5 w-5 text-indigo-600" />
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

Notification.layout = (page) => (
    <Authenticated title={"Notifications"} children={page} />
);

export default Notification;
